let forms = {
	type: {
		icon: 'fa fa-user',
		title: 'Top Up',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'paymentType',
				filterable: true,
				clearable: true,
				options: [{}],
				validation: 'required',
				label: 'Payment Type',
			},
		],
	},
	account_details: {
		icon: 'fa fa-user',
		title: 'Top Up',
		subtitle: 'Provide Main Details',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'account',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Account',
			},
			{
				type: 'text',
				form_type: 'number',
				class: 'col-12',
				model: 'amount',
				validation: 'required|numeric|min:1|max:8',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
		],
	},
	add_card: {
		icon: 'fa fa-user',
		title: 'Add Card',
		subtitle: 'Provide card Details',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'account',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Account',
			},
			{
				type: 'text',
				form_type: 'number',
				class: 'col-12 col-md-6',
				model: 'amount',
				validation: 'required|numeric|min:1|max:8',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
			{
				type: 'select',
				class: 'col-12 col-md-6',
				model: 'currency',
				filterable: true,
				clearable: true,
				options: [
					{ val: 'KES', label: 'KES' },
					{ val: 'USD', label: 'USD' },
				],
				validation: 'required',
				label: 'Currency',
			},
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'saveCard',
				validation: 'required',
				label: 'Save top up option',
			},
			// {
			//    type: 'text', form_type: 'number', class: 'col-12', model: 'card_number',
			//    validation: 'required|numeric|min:16|max:16', label: 'Card Number', placeholder: 'Enter details'
			// },
			// {
			//    type: 'datepicker', form_type: 'month', format: 'MM-yy', placement: 'bottom-end', placeholder: 'Enter',
			//    model: 'expiry', label: 'MM/YY', class: 'col-12 col-md-6', validation: 'required'
			// },
			// {
			//    type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'cvv',
			//    validation: 'required|numeric|min:3|max:3', label: 'CVV', placeholder: 'Mendoza'
			// },
		],
	},
	mpesa_checkout: {
		icon: 'fa fa-user',
		title: 'Mobile Topup',
		subtitle: 'Provide mobile details',
		forms: [
			{
				type: 'mobile',
				class: 'col-12',
				model: 'mobileNumber',
				filterable: true,
				validation: 'required',
				label: 'Mobile Number',
				placeholder: 'e.g. 712******',
			},
		],
	},
	saved_top_up_options: {
		icon: 'fa fa-user',
		title: 'Mobile Topup',
		subtitle: 'Provide mobile details',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'top_up_options',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Saved Top Up Options',
			},
		],
	},
	top_up: {
		icon: 'fa fa-user',
		title: 'Mobile Topup',
		subtitle: 'Provide mobile details',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'name',
				validation: 'min:3|max:100',
				label: 'Name',
				placeholder: 'Top up Option Name',
			},
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'saveTopUp',
				validation: '',
				label: 'Save top up option',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
